<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.Charge')"
    width="1200px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
    :append-to-body="true"
    @close="$emit('close')"
  >
    <div class="tabs-container">
      <tab-charges
        ref="tabCharge"
        style="height: 600px;padding:0;min-width:1180px"
        :context="chargeDialog.context"
        :action="chargeDialog.action"
        :is-bpm="true"
      />
    </div>
  </el-dialog>
</template>

<script>
import TabCharges from '@/components/Cargo/Job/booking/tabs/tabCharges'
import { deepCopy } from '@/utils/commonUtil'

export default {
  name: 'ChargeDialog',
  components: { TabCharges },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    job: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      chargeDialog: {
        context: {
          modifiedData: {}
        },
        action: 'look'
      },
      fullscreenLoading: null
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    innerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.init()
        })
      }
    }
  },
  methods: {
    async init() {
      this.$refs['tabCharge'].onShow(deepCopy(this.job, null), true)
    }
  }
}
</script>

<style scoped>

</style>
